import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {DashboardModel} from "../../models/dashboard.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import * as _ from "lodash";
import {DashboardsServiceService} from "../../services/dashboards-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {WidgetModel} from "../../models/widget.model";
import {DataSourceConfigurationModel} from "../../models/data-source-configuration.model";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {DashboardWidgetConfigurationEnum} from "../../enums/dashboard-widget-configuration.enum";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";

export class DashboardsViewComponents implements IController {

  favoriteDashboardSettings: ViewSettingsModel;
  favoriteDashboard: DashboardModel;
  datasourceConfigurations: DataSourceConfigurationModel[];
  userOperationalData: any;

  public isDashboardsListOpen: boolean = false;
  public dashboardForm: DashboardModel;
  public widgetForm: WidgetModel;
  public selectedDashboard: DashboardModel;
  // Derived from the selected dashboard's widgets, see setDashboardFilterOptions()
  public dashboardIncludeFilters: SiteFiltersType[] = [];
  public dashboardFilterOptionIdsMap: { [SiteFiltersType.dateRangeTemplateType]?: DateRangeTemplateType[] } = {};
  public dashboardFilters: { dateRangeTemplateType?: DateRangeTemplateType, programTypes?: string[] } = {};
  // When set, overrides the time range of every widget whose datasource supports date filtering
  public dateRange: { dateStart: number, dateEnd: number };
  // When set, overrides the program types of every widget whose datasource supports them
  public programTypes: string[];
  public currentUser: any;
  public maximumWidgetsPerDashboard: number;
  public reOrderWidgetMode: boolean = false;
  public isCopyDashboardAction: boolean = false;
  public dashboardWidgetConfiguration: typeof DashboardWidgetConfigurationEnum = DashboardWidgetConfigurationEnum;
  public datasourceConfigurationsMap: any;
  public hasPermissionToCreatePublicDashboard: boolean;
  public userBranchesIntersectionTeamMap: any;
  public isBigScreen: boolean;

  constructor(private confirmDialogService: ConfirmDialogService, private dashboardsServiceService: DashboardsServiceService,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private viewSettingsService: ViewSettingsService,
              private UUIDService, private UserService, private siteContextService: SiteContextService, private $timeout: ITimeoutService,
              private IAMPermissions, private $mdMedia) {
  }

  $onInit() {

    this.setBranchesIntersectionTeamsMap(this.userOperationalData.branches, this.userOperationalData.teams);

    this.datasourceConfigurationsMap = {};
    this.datasourceConfigurations.forEach(item => {
      this.datasourceConfigurationsMap[item.widgetDatasource] = item;
    })

    this.hasPermissionToCreatePublicDashboard = this.IAMPermissions.hasPermission('dashboard.publish');
    this.maximumWidgetsPerDashboard = this.siteContextService.getSiteInfo().dashboardAllowedNumberOfWidgets;
    this.currentUser = this.UserService.getCurrentUser();
    if (!this.favoriteDashboard) {
      this.isDashboardsListOpen = true;
    } else {
      this.setSelectedDashboard(this.favoriteDashboard);
    }
  }

  $doCheck() {
    this.isBigScreen = this.$mdMedia('gt-sm');
  };

  onToggleDashboardsListSideNav(value) {
    if (value && (this.dashboardForm)) {
      this.onCloseForm().then(() => {
        this.dashboardForm = undefined;
        this.widgetForm = undefined;
        this.isDashboardsListOpen = value;
      })

    } else {
      this.isDashboardsListOpen = value;
    }
  }

  onToggleCreateDashboard() {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm) {
      return;
    }
    this.dashboardForm = {name: undefined, isPublic: false, widgetViewConfigurations: [], dashboardDesign: {}};
  }

  closeForm() {
    this.onCloseForm().then(() => {
      this.dashboardForm = undefined;
      this.widgetForm = undefined;
    })
  }

  onCloseForm() {
    return this.confirmDialogService.confirm("Abort current activity", "Are you sure you want to stop your current activity? Any unsaved changes may be lost");
  }

  onCreateUpdateDashboard(dashboard: DashboardModel) {
    //call create dashboard api
    if (!!dashboard.id) {
      this.updateDashboard(dashboard)
        .then((dashboard: DashboardModel) => {
          this.setSelectedDashboard(angular.copy(dashboard));
          this.dashboardForm = undefined;

          this.$timeout(() => {

          }, 0);
        })
    } else {
      this.createDashboard(dashboard)
        .then((dashboard: DashboardModel) => {
          if (!this.favoriteDashboard) {
            this.onSetDashboardAsFavorite(dashboard);
          }
          if (!this.isCopyDashboardAction) {
            this.widgetForm = {metrics: {}, filters: {}, columns: []};
            this.dashboardForm = dashboard;
          } else {
            this.dashboardForm = undefined;
          }
          this.setSelectedDashboard(angular.copy(dashboard));
          this.isCopyDashboardAction = false;

          this.$timeout(() => {

          }, 0);
        })
    }
  }

  createDashboard(dashboard: DashboardModel) {
    return this.dashboardsServiceService.createDashboard(dashboard);
  }

  updateDashboard(dashboard: DashboardModel) {
    return this.dashboardsServiceService.updateDashboard(dashboard);
  }

  onCreateUpdateWidget(widget: WidgetModel, isCreateAnother: boolean) {
    if (!widget.identification) {
      widget.identification = this.UUIDService.generate();
      if (!this.dashboardForm.dashboardDesign) {
        this.dashboardForm.dashboardDesign = {};
      }
      if (!this.dashboardForm.dashboardDesign.widgetSizeConfiguration) {
        this.dashboardForm.dashboardDesign.widgetSizeConfiguration = {}
      }
      this.dashboardForm.dashboardDesign.widgetSizeConfiguration[widget.identification] = {
        id: widget.identification,
        cols: 4,
        rows: 12,
        y: 0,
        x: 0,
        ...this.dashboardWidgetConfiguration[widget.datasource][widget.widgetType]
      };
    }
    if (!this.dashboardForm.widgetViewConfigurations) {
      this.dashboardForm.widgetViewConfigurations = []
    }

    const widgetIndex = this.selectedDashboard.widgetViewConfigurations.findIndex(w => w.identification === widget.identification);

    if (widgetIndex === -1) {
      this.dashboardForm.widgetViewConfigurations.push(widget);
    } else {
      this.dashboardForm.widgetViewConfigurations[widgetIndex] = widget;
    }

    this.dashboardsServiceService.updateDashboard(this.dashboardForm)
      .then((dashboard: DashboardModel) => {
        this.setSelectedDashboard(angular.copy(dashboard));
        if (isCreateAnother) {
          this.dashboardForm = dashboard;
          this.widgetForm = {metrics: {}, filters: {}, columns: []};
        } else {
          this.dashboardForm = undefined;
          this.widgetForm = undefined;
        }

        this.$timeout(() => {

        }, 0);
      })
  }

  onEditDashboard() {
    this.isDashboardsListOpen = false;


    if (this.widgetForm || this.dashboardForm) {
      this.onCloseForm().then(() => {
        this.widgetForm = undefined;
        this.dashboardForm = undefined;

        this.dashboardForm = angular.copy(this.selectedDashboard);
      });
    } else {
      this.dashboardForm = angular.copy(this.selectedDashboard);
    }
  }

  onSelectDashboard(dashboard: DashboardModel) {
    this.setSelectedDashboard(undefined);
    this.$timeout(() => {
      this.setSelectedDashboard(angular.copy(dashboard));
    }, 0);
  }

  onSetDashboardAsFavorite(dashboard: DashboardModel) {
    if (this.favoriteDashboardSettings) {
      const favoriteDashboardSettingsCopy = {...this.favoriteDashboardSettings, pageName: dashboard.id}
      this.viewSettingsService.updateByUser(favoriteDashboardSettingsCopy.id, favoriteDashboardSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.favoriteDashboardSettings = viewSettingsTable;
          this.favoriteDashboard = dashboard;
        })
    } else {
      const viewTableSettings = {
        pageName: dashboard.id,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.Dashboard
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.favoriteDashboardSettings = viewSettingsTable;
          this.favoriteDashboard = dashboard;
        })
    }
  }

  // Only reassign the filters that changed, so widgets refetch just for what actually changed.
  // Compared against the applied values (not dashboardFilters), since removing a filter chip mutates dashboardFilters in place.
  onDashboardFiltersChange(filters: { dateRangeTemplateType?: DateRangeTemplateType, programTypes?: string[] }) {
    const range = filters?.dateRangeTemplateType && this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    const dateRange = range ? {dateStart: range.dateStart, dateEnd: range.dateEnd} : undefined;
    if (!_.isEqual(dateRange, this.dateRange)) {
      this.dateRange = dateRange;
    }

    const programTypes = filters?.programTypes?.length ? [...filters.programTypes] : undefined;
    if (!_.isEqual(programTypes, this.programTypes)) {
      this.programTypes = programTypes;
    }

    this.dashboardFilters = {...filters};
  }

  onAddWidget() {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm || this.widgetForm) {
      this.onCloseForm().then(() => {
        this.dashboardForm = angular.copy(this.selectedDashboard);
        this.widgetForm = {metrics: {}, filters: {}, columns: []};
      })
    } else {
      this.dashboardForm = angular.copy(this.selectedDashboard);
      this.widgetForm = {metrics: {}, filters: {}, columns: []};
    }
  }

  deleteDashboard() {
    this.dashboardsServiceService.deleteDashboard(this.selectedDashboard.id).then(() => {
      this.setSelectedDashboard(undefined);
    })
  }

  onCopyDashboard() {
    this.dashboardForm = {...this.selectedDashboard, id: undefined, ownerId: undefined, ownerName: undefined};
    if (this.dashboardForm.isPublic && !this.hasPermissionToCreatePublicDashboard) {
      this.dashboardForm.isPublic = false;
    }
    this.isDashboardsListOpen = false;
    this.isCopyDashboardAction = true;
  }

  onEditWidget(widget: WidgetModel) {
    this.isDashboardsListOpen = false;

    if (this.dashboardForm || this.widgetForm) {
      this.onCloseForm().then(() => {
        this.widgetForm = angular.copy(widget);
        this.dashboardForm = angular.copy(this.selectedDashboard);
      })
    } else {
      this.widgetForm = angular.copy(widget);
      this.dashboardForm = angular.copy(this.selectedDashboard);
    }
    this.$timeout(0).then(() => {
    });
  }

  onDeleteWidget(data: { index: number, widget: WidgetModel }) {
    let dashboardCopy = angular.copy(this.selectedDashboard);
    dashboardCopy.widgetViewConfigurations.splice(data.index, 1);

    if (!!dashboardCopy.dashboardDesign?.widgetSizeConfiguration && !!dashboardCopy.dashboardDesign?.widgetSizeConfiguration[data.widget.identification]) {
      delete dashboardCopy.dashboardDesign.widgetSizeConfiguration[data.widget.identification]
    }

    this.dashboardsServiceService.updateDashboard(dashboardCopy).then(() => {
      this.selectedDashboard.widgetViewConfigurations.splice(data.index, 1);
      this.setDashboardFilterOptions();

      this.$timeout(0).then(() => {
      });
    })
  }

  onChangeDashboardPublicState(isPublic: boolean) {
    this.dashboardsServiceService.changeDashboardPublicState(this.selectedDashboard.id, isPublic).then((updatedDashboard: DashboardModel) => {
      this.selectedDashboard.isPublic = updatedDashboard.isPublic;
    })
  }

  private setSelectedDashboard(dashboard: DashboardModel) {
    this.selectedDashboard = dashboard;
    this.setDashboardFilterOptions();
  }

  // Offers only the dashboard filters the selected dashboard's widgets support:
  // date range options shared by all date-filterable widgets, and program types if any widget supports them
  private setDashboardFilterOptions() {
    const widgetsDatasourceConfigurations: DataSourceConfigurationModel[] = _.compact(
      (this.selectedDashboard?.widgetViewConfigurations || []).map(widget => this.datasourceConfigurationsMap[widget.datasource])
    );

    // A datasource with no date range options allows all of them (same as date-range-template-type-select-section)
    const dateRangeOptions = _.intersection(...widgetsDatasourceConfigurations
      .filter(config => config.filters?.includes(SiteFiltersType.dateRangeTemplateType))
      .map(config => config.dateRangeTemplateOptions?.length ? config.dateRangeTemplateOptions : Object.values(DateRangeTemplateType)));
    const hasProgramTypes = widgetsDatasourceConfigurations.some(config => config.filters?.includes(SiteFiltersType.programTypes));

    this.dashboardFilterOptionIdsMap = {[SiteFiltersType.dateRangeTemplateType]: dateRangeOptions};
    this.dashboardIncludeFilters = [
      ...(dateRangeOptions.length ? [SiteFiltersType.dateRangeTemplateType] : []),
      ...(hasProgramTypes ? [SiteFiltersType.programTypes] : [])
    ];

    // Drop selections that are no longer available for this dashboard's widgets
    this.onDashboardFiltersChange({
      dateRangeTemplateType: dateRangeOptions.includes(this.dashboardFilters.dateRangeTemplateType) ? this.dashboardFilters.dateRangeTemplateType : undefined,
      programTypes: hasProgramTypes ? this.dashboardFilters.programTypes : undefined
    });
  }

  private setBranchesIntersectionTeamsMap(userBranches, userTeams) {
    this.userBranchesIntersectionTeamMap = {
      branchIds: [],
      agentIds: []
    }
    if (!userBranches?.length || !userTeams?.length) {
      return;
    }

    const userTeamAgents = _.uniqBy(_.flatMap(userTeams, 'agents'), 'id');

    userBranches.forEach(branch => {
      userTeamAgents.forEach(agent => {
        if (agent.branchIds?.includes(branch.id)) {
          this.userBranchesIntersectionTeamMap.branchIds.push(branch.id);
          this.userBranchesIntersectionTeamMap.agentIds.push(agent.id);
        }
      })
    })

    this.userBranchesIntersectionTeamMap.branchIds = _.uniq(this.userBranchesIntersectionTeamMap.branchIds);
    this.userBranchesIntersectionTeamMap.agentIds = _.uniq(this.userBranchesIntersectionTeamMap.agentIds);
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardsView', {
    bindings: {
      datasourceConfigurations: '<',
      favoriteDashboardSettings: '<?',
      favoriteDashboard: '<?',
      userOperationalData: '<?'
    },
    template: require('./dashboards-view.html').default,
    controller: DashboardsViewComponents
  });
